import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Barcode from "react-barcode";
import { getEmailSummaryRequest } from "../../../../Backend/BooksRequests";
import { getStateName } from "../../../../Constants/BarcodeBookState";
import { getReportTypeName } from "../../../../Constants/ReportTypes";
import {
  bookNumberMask,
  displayDate,
  objectToQueryString,
} from "../../../../Helpers/utils/utils";
import { hasValue } from "../../../../Helpers/validations/common";
import "./SummaryBooks.scss";

export function SummaryBooks() {
  const navigate = useNavigate();
  const [t] = useTranslation();
  const firstPageBooks = 6;
  const booksPerPage = 9;
  const urlParams = new URLSearchParams(window.location.search);
  const [code] = useState(urlParams.get("code"));
  const [errorSummary, setErrorSummary] = useState(false);
  const [userData, setUserData] = useState({
    adress: null,
    city: null,
    country: null,
    customerId: null,
    currentBarcode: "",
    showAdvice: false,
    email: "",
    firstName: "",
    id: "",
    lastName: "",
    postalCode: "",
    preposition: "",
    returnedId: null,
    role: null,
    roleNames: [],
    schoolId: null,
    schoolName: "",
    schoolNumber: null,
    softEmail: "",
    userName: "",
  });
  const [books, setBooks] = useState([]);
  const [barcode, setBarcode] = useState({
    barcode: 0,
    classNumber: "",
    completeDate: new Date(),
    id: "",
    isCompleted: false,
    userId: "",
    year: 0,
  });
  const [dates, setDates] = useState({
    end: new Date(),
    returnLocation: "",
    start: new Date(),
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSummary();
  }, []);

  const getSummary = async () => {
    setLoading(true);
    const params = {
      code: code,
    };

    var data = await getEmailSummaryRequest(objectToQueryString(params, true));

    if (data.success) {
      setBooks(data.data.books.filter((x) => x.isEnabled && x.isInvoiceAplied));
      setDates(data.data.dates);
      setUserData(data.data.user);
      setBarcode(data.data.barcode);
      setErrorSummary(false);
      setLoading(false);
    } else {
      setErrorSummary(true);
      setLoading(false);
    }
    
  };

  const renderBooks = (startIdx, endIdx) => {
    let html = [];
    const maxIdx = books.length > endIdx ? endIdx : books.length;
    for (let index = startIdx; index < maxIdx; index++) {
      const book = books[index];
      html.push(
        <div className={"book"} key={"book-" + index}>
          <div className="title-wrapper">
            <div className="title">{book.book.title}</div>
            <div className="status-wrapper">
              <div className={`status ${getStateName(book.state)}`}>
                {t(getStateName(book.state))}
              </div>
            </div>
          </div>
          <div className="body-wrapper">
            <div className="left">
              <div className="isbn">ISBN: {book.book.isbn}</div>
              <div className="number">
                #{bookNumberMask(book.book.bookNumber)}
              </div>
            </div>
            <div className="right">
              {hasValue(book.reportType) && book.reportType !== 0 && (
                <div className="report-type">
                  {t(getReportTypeName(book.reportType))}
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }

    return html;
  };

  const renderFirstPage = () => {
    return (
      <div className="first-page-wrapper">
        <div className="info-wrapper">
          <div className="left-wrapper">
            <span className="title">{t("Information")}</span>
            {info.map((x) => (
              <div className="info-row" key={"info-" + x.key}>
                <span className="key">{x.key}:</span>
                <span className="value">{x.value}</span>
              </div>
            ))}
          </div>
          <div className="right-wrapper">
            <span className="class">{barcode.classNumber}</span>
            <div className="barcode">
              <Barcode value={barcode.barcode.toString()} width={3} />
            </div>
          </div>
        </div>
        {renderBooks(0, firstPageBooks)}
        {footerPage(1)}
      </div>
    );
  };

  const renderMorePages = () => {
    const pages = [];
    let page = 2;

    if (books.length > firstPageBooks) {
      for (
        let start = firstPageBooks, end = start + booksPerPage;
        start < books.length;
        start = end, end += booksPerPage
      ) {
        pages.push(
          <div className="page-wrapper" key={"page-" + page}>
            {renderBooks(start, Math.min(end, books.length))}
            {footerPage(page)}
          </div>
        );
        page++;
      }
    }

    return pages;
  };

  const footerPage = (page) => {
    return (
      <footer className="footer">
        <span className="year">{barcode.year}</span>
        <span className="sanoma-company-text">{t("NotLoggedCompany")}</span>
        <span className="page-count">{t("Page") + " " + page}</span>
      </footer>
    );
  };

  const info = [
    { key: t("StartDate"), value: displayDate(dates.start) },
    { key: t("EndDate"), value: displayDate(dates.end) },
    { key: t("ReturnedLocation"), value: dates.returnLocation },
    { key: t("Completed"), value: displayDate(barcode.completeDate) },
    {
      key: t("Student"),
      value: `${userData.firstName} ${userData.preposition}, ${userData.lastName}`,
    },
    { key: t("CustomerId"), value: userData.customerId },
    { key: t("School"), value: userData.schoolName },
    { key: t("SchoolNumber"), value: userData.schoolNumber },
    // {
    //   key: t("Address"),
    //   value: `${userData.adress}, ${userData.city}, ${userData.postalCode}`,
    // },
  ];

  return (
    <div className="summary-books trans-fromTop">
      <div className="print-wrapper">
        <header className="header">
          <div className="img-wrapper">
            <img src="/InleverWhiteIcon.svg" alt="image" />
            <img className="pt-1" src="/InleverWhiteLogo.svg" alt="image" />
          </div>
          <div className="user-info">
            <div className="title-summary">{t("Summary")}</div>
          </div>
        </header>
        <main className="main">
          <div className="buttons-wrapper no-print">
            <div
              className="goback outlined"
              onClick={() => navigate(-1)}
              role="link"
              id={"goback-button"}
            >
              <div className="text">{t("GoBack")}</div>
            </div>
            <div
              className="goback"
              onClick={() => window.print()}
              role="link"
              id={"goback-button"}
            >
              <div className="text">{t("Print")}</div>
            </div>
          </div>
          {loading ? (
            <div className="loader-container">
              <div className="loader" />
            </div>
          ) : errorSummary === false ? (
            <React.Fragment>
              {renderFirstPage()}
              {renderMorePages()}
            </React.Fragment>
          ) : (
            <div className="error-summary-wrapper">
              {t("ErrorSummaryMessage")}
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
